import { render, staticRenderFns } from "./DetailBlog5.vue?vue&type=template&id=9bbc1fec&"
import script from "./DetailBlog5.vue?vue&type=script&lang=js&"
export * from "./DetailBlog5.vue?vue&type=script&lang=js&"
import style0 from "./DetailBlog5.vue?vue&type=style&index=0&id=9bbc1fec&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bbc1fec')) {
      api.createRecord('9bbc1fec', component.options)
    } else {
      api.reload('9bbc1fec', component.options)
    }
    module.hot.accept("./DetailBlog5.vue?vue&type=template&id=9bbc1fec&", function () {
      api.rerender('9bbc1fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailBlog5.vue"
export default component.exports